import dayjs from "dayjs";
import { HAZTEOIR_LANGUAGE, isHazteoirHost } from "./utils/hostRouting";

export const COLORS = {
  fontColor: "#363135",
  linkColor: "#2a6ce0",
  greyColor: "#dbd9db",
  lightGreyColor: "#eaeded",
  hoOrange: "rgb(237, 139, 0)",
  hoOrangeHover: "#ab6400",
  hoDarkerOrange: "#b35600",
  hoOrangeDisabled: "#edbb99",
  cgoBlue: "#4281f0",
  cgoDarkerBlue: "#0b3b8e",
  cgoBlueDisabled: "#8abbdf",
  black: "#363135",
  sliderNavColor: "#adacad",
  darkGrey: "#737273",
  red: "#B3150F",
  scarlet: "#ff2400",
  darkRed: "#b32c0e",
  white: "#fff",
  footerColor: "#f6f4f6",
  footerFontColor: "#666",
  shareGreen: "#00c300",
  facebookColor: "#37639e",
  facebookHoverColor: "#2f5587",
  whatsAppColor: "#69ca36",
  messengerGradient: "linear-gradient(90deg, rgba(18,134,249,1) 0%, rgba(156,44,247,1) 50%, rgba(255,80,118,1) 100%",
  messengerHoverGradient: "linear-gradient(90deg, rgba(15, 110, 205, 1) 0%, rgba(127, 35, 202, 1) 50%, rgba(215, 65, 97, 1) 100%",
};

// Dark mode color variants
export const DARK_COLORS = {
  fontColor: "#e8e8e8",
  linkColor: "#5a9eff",
  greyColor: "#3a3a3a",
  lightGreyColor: "#2a2a2a",
  hoOrange: "rgb(255, 165, 0)",
  hoOrangeHover: "#ff8c00",
  hoDarkerOrange: "#ff8c00",
  hoOrangeDisabled: "#8b6f47",
  cgoBlue: "#5a9eff",
  cgoDarkerBlue: "#7bb3ff",
  cgoBlueDisabled: "#4a6b8f",
  black: "#e8e8e8",
  sliderNavColor: "#5a5a5a",
  darkGrey: "#9a9a9a",
  red: "#ff4444",
  scarlet: "#ff6666",
  darkRed: "#cc3333",
  white: "#1a1a1a",
  footerColor: "#1e1e1e",
  footerFontColor: "#b0b0b0",
  shareGreen: "#00ff00",
  facebookColor: "#4a7ab8",
  facebookHoverColor: "#5a8ac8",
  whatsAppColor: "#7dd856",
  messengerGradient: "linear-gradient(90deg, rgba(28,154,249,1) 0%, rgba(176,64,247,1) 50%, rgba(255,100,138,1) 100%",
  messengerHoverGradient: "linear-gradient(90deg, rgba(35, 130, 225, 1) 0%, rgba(147, 55, 222, 1) 50%, rgba(235, 85, 117, 1) 100%",
};

// Helper function to get colors based on dark mode
export const getColors = (isDarkMode = false) => {
  return isDarkMode ? DARK_COLORS : COLORS;
};
export const FONT_SIZE = {
  h1: "42.7px",
  title: "25px",
  petition_title: "20px",
  medium: "14px",
  small: "12.8px",
  smaller: "10px",
  default: "16px",
};
export const BORDER_RADIUS = "5px";

const sizes = {
  desktop: "1024",
  tablet: "768px",
  mobile: "430px",
};

export const MEDIA_QUERIES = {
  DESKTOP: `(min-width: ${sizes.desktop})`,
  TABLET: `(max-width: ${sizes.tablet})`,
  MOBILE: `(max-width: ${sizes.mobile})`,
};

export const _API_ENDPOINT = {
  join_us: "api/v1/join-us",
  petitions: "api/v1/petition",
  petition: "api/v1/single_petition/",
  members_count: "api/v1/member-count",
  store_shortcut: "api/v1/store-shortcut",
  country_list: "api/get_country_list",
  zip_code_rules: "api/get_country_zipcode_rule",
  sign_petition: "api/sign_petition",
  verify_email: "api/verifyEmail",
  scramble_email: "api/v1/marketo/unsubscription/scramble-email",
  uncheck_myopt: "api/v1/marketo/unsubscription/uncheck-myopt"
}

export const LANGUAGES = [
  {
    code: "de",
    name: "Deutsch",
    otd: "spenden",
    md: "mitglied",
    shareDonation: "LP3-OTD-Form-DE",
    donateShare: "LP2b-OTD-form-DE",
  },
  {
    code: "de-at",
    name: "Deutsch-Österreich",
    otd: "de-at-spenden",
    md: "mitglied",
    shareDonation: "LP3-OTD-Form-DE-AT",
    donateShare: "LP2b-OTD-form-DE_AT",
  },
  {
    code: "de-ch",
    name: "Deutsch-Schweiz",
    otd: "de-ch-spenden",
    md: "mitglied",
    shareDonation: "LP3-OTD-form-DE-CH",
    donateShare: "LP2b-OTD-form-DE_CH",
  },
  // {
  //   code: "en",
  //   name: "English",
  //   otd: "en-USA-donate",
  //   md: "en-USA-donate-membership",
  //   shareDonation: "LP3-OTD-form-EN",
  //   donateShare: "LP2b-OTD-form-EN",
  // },
  {
    code: "en-af",
    name: "English-Africa",
    otd: "en-AF-donate",
    md: "en-af-become-a-member",
    shareDonation: "LP2b-OTD-form-EN",
    donateShare: "LP2b-OTD-form-EN_AF",
  },
  {
    code: "en-au",
    name: "English-Australia",
    otd: "en-AU-donate",
    md: "au-become-a-member",
    shareDonation: "LP3-OTD-form-EN-AU",
    donateShare: "LP2b-OTD-form-EN_AU",
  },
  {
    code: "en-ca",
    name: "English-Canada",
    otd: "en-CA-donate",
    md: "en-CA-donate-membership",
    shareDonation: "LP3-OTD-form-EN-CA",
    donateShare: "LP2b-OTD-form-EN_CA",
  },
  {
    code: "en-ie",
    name: "English-Ireland",
    otd: "en-IE-donate",
    md: "gb-become-a-member2",
    shareDonation: "LP3-OTD-form-EN-IE",
    donateShare: "LP2b-OTD-form-EN_IE",
  },
  {
    code: "en-row",
    name: "English-Other countries",
    otd: "en-ROW-donate",
    md: "en-row-become-a-member",
    shareDonation: "LP3-OTD-form-EN-ROW",
    donateShare: "LP2b-OTD-form-EN_ROW",
  },
  {
    code: "en-gb",
    name: "English-United Kingdom",
    otd: "en-GB-donate",
    md: "gb-become-a-member2",
    shareDonation: "LP3-OTD-form-EN-GB",
    donateShare: "LP2b-OTD-form-EN_GB",
  },
  {
    code: "en-us",
    name: "English-United States",
    otd: "en-USA-donate",
    md: "en-USA-donate-membership",
    shareDonation: "LP3-OTD-form-EN",
    donateShare: "LP2b-OTD-form-EN",
  },
  {
    code: "es-ar",
    name: "Español-Argentina",
    otd: "ar",
    md: "ar-socio",
    shareDonation: "LP3-OTD-form-ES-AR",
    donateShare: "LP2b-OTD-form-ES_AR",
  },
  {
    code: "es-lat",
    name: "Español-América Latina",
    otd: "ltm-donativo",
    md: "ltm-socio",
    shareDonation: "LP3-OTD-form-ES-LAT",
    donateShare: "LP2b-OTD-form-ES_ROW",
  },
  {
    code: "hazteoir",
    name: "Español-España",
    otd: "hazundonativo-ho",
    md: "haztesocio",
    shareDonation: "LP3-OTD-form-ES-HO",
    donateShare: "LP2b-OTD-form-HO",
  },
  {
    code: "es-mx",
    name: "Español-México",
    otd: "mx-donativo",
    md: "mx-socio",
    shareDonation: "LP3-OTD-form-ES-MX",
    donateShare: "LP2b-OTD-form-ES-MX",
  },
  {
    code: "es-us",
    name: "Español-United States",
    otd: "es-us-donativo",
    shareDonation: "LP3-OTD-form-ES-US",
    donateShare: "LP2b-OTD-form-ES-US",
  },
  {
    code: "fr-fr",
    name: "Français",
    otd: "donner",
    md: "fr-membre",
    shareDonation: "LP3-OTD-form-FR",
    donateShare: "LP2b-OTD-form-FR",
  },
  {
    code: "fr-ca",
    name: "Français-Canada",
    otd: "fr-ca-donner",
    shareDonation: "LP3-OTD-form-FR-CA",
  },
  {
    code: "hr",
    name: "Hrvatski",
    otd: "doniraj",
    md: "hr-monthly-donation",
    shareDonation: "LP3-OTD-form-HR",
    donateShare: "LP2b-OTD-form-HR",
  },
  {
    code: "it",
    name: "Italiano",
    otd: "it-sostienici",
    md: "insieme-possiamo",
    shareDonation: "LP3-OTD-form-IT",
    donateShare: "LP2b-OTD-form-IT",
  },
  {
    code: "hu",
    name: "Magyar",
    otd: "hu-donation",
    md: "hu-monthly",
    shareDonation: "LP3-OTD-form-HU",
    donateShare: "LP2b-OTD-form-HU",
  },
  {
    code: "nl",
    name: "Nederlands",
    otd: "doneren",
    md: "word-lid",
    shareDonation: "LP3-OTD-form-NL",
    donateShare: "LP2b-OTD-form-NL",
  },
  {
    code: "nl-be",
    name: "Nederlands-België",
    otd: "nl-be-doneren",
    md: "nl-be-word-lid",
    shareDonation: "LP3-OTD-form-NL-BE",
    donateShare: "LP2b-OTD-form-NL-BE",
  },
  {
    code: "pl",
    name: "Polski",
    otd: "darowizna",
    md: "pl-monthly",
    shareDonation: "LP3-OTD-form-PL",
    donateShare: "LP2b-OTD-form-PL",
  },
  {
    code: "pt-br",
    name: "Português-Brasil",
    otd: "br-doar",
    md: "br-doar",
    shareDonation: "LP3-OTD-form-PT-BR",
    donateShare: "LP2b-OTD-form-PT_BR",
  },
  {
    code: "pt-pt",
    name: "Português-Portugal",
    otd: "pt-doar",
    md: "pt-mensal",
    shareDonation: "LP3-OTD-form-PT-PT",
    donateShare: "LP2b-OTD-form-PT_PT",
  },
  {
    code: "sk",
    name: "Slovenčina",
    otd: "sk-donation",
    md: "sk-monthly",
    shareDonation: "LP3-OTD-form-SK",
    donateShare: "LP2b-OTD-form-SK",
  },
];

export const TESTAPI = "http://localhost:9988/v1/petition/";
export const LOCAL_JSON = "staticData/petitions.json";
export const HOST = `${window.location.protocol}//${window.location.host}`;
export let REMINDER_TIOMEOUT = 180000;

// export const OTD_BASE_URL = "https://go.citizengo.org";
export const OTD_BASE_URL = "https://donate.citizengo.org";
export const LP2_SHARE = "LP2-Share";

export function showTop() {
  window.scrollTo({ top: 0, left: 0 });
}
export const REDIRECT_TO_HAZTEOIR = isHazteoirHost()
  ? window.location.origin
  : `${window.location.origin}/hazteoir`;
export const REDIRECT_TO_HOME_PAGE = window.location.origin;
export const URL_EXCEPTION_REGEX = /(https?:\/\/|\s|\P{L})/gu;

export const URLParams = (mParam, nid, id, utm_campaign) => {
  return `?m=${mParam}&nid=${nid !== null ? nid : id}${
    utm_campaign ? `&utm_campaign=${utm_campaign}` : ""
  }`;
};

export const topicsShortcutFunc = (topic) => {
  const topicsMap = {
    'oth': 'ot',
    'lfe': 'lf',
    'fam': 'fm',
    'edu': 'ed',
    'sol': 'sd',
    'pol': 'pt',
    'fre': 'fr',
    'ele': 'el',
    'pat': 'pt'
  };
  return topicsMap[topic];
};

export const region = isHazteoirHost()
  ? HAZTEOIR_LANGUAGE
  : window.location.pathname.split("/")[1];
export const helpscoutURL = "https://help.citizengo.org";

const getHelpscoutRegion = () => {
  const regionAliases = {
    "vls-be": "nl-be",
  };
  return regionAliases[region] || region;
};

const getHelpscoutMappedId = (idMap) => {
  const currentRegion = getHelpscoutRegion();
  for (const pattern in idMap) {
    if (pattern === "default") continue;
    if (new RegExp(`^${pattern}`).test(currentRegion)) {
      return idMap[pattern];
    }
  }
  return idMap.default;
};

export const aboutHelpscoutId = () => {
  const aboutIdMap = {
    "en.*": "906",
    "de.*": "904",
    "es.*": "921",
    "pt.*": "969",
    hazteoir: "890",
    fr: "905",
    hr: "937",
    hu: "953",
    it: "944",
    pl: "960",
    sk: "984",
    "nl-be": "1387",
    nl: "976",
    default: "896",
  };
  return getHelpscoutMappedId(aboutIdMap);
};

export const financialStatementHelpscoutId = () => {
  const financialStatementIdMap = {
    "en.*": "892",
    de: "908",
    "es.*": "923",
    "pt.*": "972",
    hazteoir: "898",
    fr: "930",
    hr: "939",
    hu: "955",
    it: "946",
    pl: "963",
    sk: "986",
    nl: "978",
    "nl-be": "1393",
    default: "896",
  };
  return getHelpscoutMappedId(financialStatementIdMap);
};

export const pressHelpscoutId = () => {
  const pressIdMap = {
    "en.*": "895",
    de: "909",
    "es.*": "925",
    "pt.*": "970",
    hazteoir: "https://prensa.hazteoir.com/",
    fr: "932",
    hr: "941",
    hu: "957",
    it: "948",
    pl: "967",
    sk: "988",
    "nl-be": "1391",
    nl: "980",
    default: "896",
  };
  return getHelpscoutMappedId(pressIdMap);
};

export const privacyHelpscoutId = () => {
  const privacyIdMap = {
    "en.*": "894",
    de: "910",
    "es.*": "926",
    "pt.*": "968",
    hazteoir: "900",
    fr: "935",
    hr: "936",
    hu: "952",
    it: "949",
    pl: "961",
    sk: "989",
    "nl-be": "1388",
    nl: "981",
    default: "896",
  };
  return getHelpscoutMappedId(privacyIdMap);
};

export const termsHelpscoutId = () => {
  const termsIdMap = {
    "en.*": "907",
    de: "911",
    "es.*": "927",
    "pt.*": "974",
    hazteoir: "903",
    fr: "934",
    hr: "942",
    hu: "958",
    it: "950",
    pl: "965",
    sk: "990",
    "nl-be": "1392",
    nl: "982",
    default: "896",
  };
  return getHelpscoutMappedId(termsIdMap);
};

export const cookiesHelpscoutId = () => {
  const cookiesIdMap = {
    "en.*": "896",
    de: "912",
    "es.*": "928",
    "pt.*": "975",
    hazteoir: "902",
    fr: "933",
    hr: "943",
    hu: "959",
    it: "951",
    pl: "966",
    sk: "991",
    "nl-be": "1390",
    nl: "983",
    default: "896",
  };
  return getHelpscoutMappedId(cookiesIdMap);
};


export const getElapsedTimeText = (created, t) => {
  const now = dayjs();
  const createdTime = dayjs(created);

  const secondsElapsed = now.diff(createdTime, 'second');

  if (secondsElapsed < 60) {
    return t(`time_units.seconds_${getPluralForm(secondsElapsed)}`, { count: secondsElapsed });
  }

  const minutesElapsed = Math.floor(secondsElapsed / 60);
  if (minutesElapsed < 60) {
    return t(`time_units.minutes_${getPluralForm(minutesElapsed)}`, { count: minutesElapsed });
  }

  const hoursElapsed = Math.floor(minutesElapsed / 60);
  if (hoursElapsed < 24) {
    return t(`time_units.hours_${getPluralForm(hoursElapsed)}`, { count: hoursElapsed });
  }

  const daysElapsed = Math.floor(hoursElapsed / 24);
  if (daysElapsed < 30) {
    return t(`time_units.days_${getPluralForm(daysElapsed)}`, { count: daysElapsed });
  }
};


const getPluralForm = (count) => {
  if (count === 1) {
    return 'one';
  } else if (count > 1 && count < 5) {
    return 'few';
  } else {
    return 'many';
  }
};

export const sharePageTitles = (tp, t) => {
  const tpMap = {
    'oth': t('share_page.share_title'),
    'lfe': t('share_page.life_title'),
    'ele': t('share_page.election_season_title'),
    'fam': t('share_page.family_and_education_title'),
    'pat': t('share_page.patriotism_title'),
    'fre': t('share_page.freedom_title')
  };
  return tpMap[tp];
}

export const docsBotAI = (lang) => {
  const L = (lang || "en").toLowerCase().replace(/_/g, "-").trim();
  const TEAM = (process.env.REACT_APP_DOCS_BOT_TEAM_ID || "").replace(/\/+$/, "");

  if (L === "hazteoir") {
    const ho = process.env.REACT_APP_DOCS_BOT_ID_HO;
    return TEAM && ho ? `${TEAM}/${ho}` : "";
  }

  const GROUPS = {
    es: ["es", "es-mx", "es-ar", "es-lat", "es-row", "es-us"],
    de: ["de", "de-at", "de-ch"],
    fr: ["fr", "fr-fr", "fr-ca"],
    pt: ["pt", "pt-pt", "pt-br"],
    nl: ["nl", "nl-be"],
  };

  const base =
    Object.entries(GROUPS).find(([, arr]) => arr.includes(L))?.[0] ||
    L.split("-")[0];

  const baseKey = `REACT_APP_DOCS_BOT_ID_${base.toUpperCase()}`;
  const baseId = process.env[baseKey];
  const fallbackId = process.env.REACT_APP_DOCS_BOT_ID_EN;

  const botId = baseId || fallbackId;
  return TEAM && botId ? `${TEAM}/${botId}` : "";
};

export const langMap = (lang) => {
  const langMap = {
    'pl-pl': 'pl',
    'hr-hr': 'hr',
    'it-it': 'it',
    'hu-hu': 'hu',
    'nl-nl': 'nl',
    'vls-be': 'nl-be',
    'es-row': 'es-lat',
    'sk-sk': 'sk',
    'de-de': 'de',
  };
  return langMap[lang] || lang;
}; 

export const getPublicPathLanguagePrefix = (lang) => {
  if (isHazteoirHost() && lang === HAZTEOIR_LANGUAGE) {
    return '';
  }

  return `/${lang}`;
};

export const buildPublicPetitionPath = (lang, topicPath, petitionPath) => {
  return `${getPublicPathLanguagePrefix(lang)}/${topicPath}/${petitionPath}`;
};

export const redirectToDonationPage = (params, m, nid, sid, fname, donationURL) => {
  return `${donationURL}?m=${m}&nid=${nid}&flowType=don&sid=${sid || ""}&fname=${fname}${params}`;
};

export const redirectToThankyouPage = (params, m, nid, sid, thankyou_page, fname) => {
  return `${thankyou_page}?m=${m}${params || ""}&nid=${nid}&sid=${sid || ""}&fname=${fname}`;
}

export const redirectToSharePage = (params, m, nid, sid, share_page, lang, fname) => {
  return `${share_page}?m=${m}&nid=${nid}&sid=${sid || ""}&list=${lang}&fname=${fname}${params}`;
}

export const langMapping = (lang) => {

  const langMap = {
     'de-at': 'de-at',
     'de-ch': 'de-ch',
     'de': 'de-de',
     'de-de': 'de-de',
     'en-af': 'en-af',
     'en-au': 'en-au',
     'en-ca': 'en-ca',
     'en-gb': 'en-gb',
     'en-ie': 'en-ie',
     'en-row': 'en-row',
     'en-us': 'en-us',
     'es-ar': 'es-ar',
     'hazteoir': 'es-ho',
     'es-ho': 'es-ho',
     'es-mx': 'es-mx',
     'es-lat': 'es-row',
     'es-us': 'es-us',
     'es-row': 'es-lat',
     'fr-ca': 'fr-ca',
     'fr': 'fr-fr',
     'fr-fr': 'fr-fr',
     'hr': 'hr-hr',
     'hr-hr': 'hr-hr',
     'hu': 'hu-hu',
     'hu-hu': 'hu-hu',
     'it': 'it-it',
     'it-it': 'it-it',
     'nl': 'nl-nl',
     'nl-nl': 'nl-nl',
     'pl': 'pl-pl',
     'pl-pl': 'pl-pl',
     'pt-br': 'pt-br',
     'pt-pt': 'pt-pt',
     'sk-sk': 'sk-sk',
     'sk': 'sk-sk',
     'nl-be': 'vls-be',
   };
   return langMap[lang] || 'en-row';
 }
